/* Medivital landing: saját csomagválasztó a Kaching Bundles fölött.
   A Kaching marad a motor (kedvezmény, méretek, kosár-tulajdonság), ez csak a felület. */
(function () {
  var EMOJI = /[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{23F0}-\u{23FF}\u{FE0F}]/gu;
  var PRICE = /\d{1,3}(?:[.\s]\d{3})*\s?Ft/g;
  function txt(el) { return el ? el.textContent.replace(EMOJI, '').replace(/\s+/g, ' ').trim() : ''; }

  function readBars(k) {
    return Array.prototype.map.call(k.querySelectorAll('.kaching-bundles__bar'), function (bar, i) {
      var sub = txt(bar.querySelector('.kaching-bundles__bar-subtitle'));
      var prices = sub.match(PRICE) || [];
      var pct = (sub.match(/[-−]\s?\d+\s?%/) || [''])[0].replace('-', '−').replace(/\s/g, '');
      var unitEl = bar.querySelector('.kaching-bundles__bar-price');
      var unitLabel = txt(bar.querySelector('.kaching-bundles__bar-price__unit-label'));
      var unit = txt(unitEl).replace(unitLabel, '').trim();
      return {
        el: bar,
        selected: bar.classList.contains('kaching-bundles__bar--selected'),
        title: txt(bar.querySelector('.kaching-bundles__bar-title')).replace(/Pár/g, 'pár'),
        badge: i === 0 ? '' : txt(bar.querySelector('.kaching-bundles__bar-most-popular__content')),
        unit: unit, unitLabel: unitLabel || '/pár',
        total: prices[0] || unit,
        old: prices[1] || txt(bar.querySelector('.kaching-bundles__bar-full-price')),
        pct: pct,
        selects: bar.querySelectorAll('select.kaching-bundles__bar-variant-select')
      };
    });
  }

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function render(k, box) {
    var bars = readBars(k);
    if (!bars.length) return;
    /* csak valódi változásnál rajzolunk újra, különben a nyitott lenyíló bezárul */
    var sig = JSON.stringify(bars.map(function (b) { return [b.title, b.badge, b.unit, b.total, b.old, b.pct, b.selected, Array.prototype.map.call(b.selects, function (s) { return s.value + '/' + s.options.length; })]; }));
    if (sig === box.dataset.sig) return;
    var act = document.activeElement;
    if (act && act.tagName === 'SELECT' && box.contains(act)) { setTimeout(function () { render(k, box); }, 400); return; }
    box.dataset.sig = sig;
    var html = '<div class="mvlp-offer__head"><span>Válassz csomagot</span><span>S 35–39 · M 40–43 · L 44–47</span></div>';
    bars.forEach(function (b, i) {
      html += '<div class="mvlp-offer__card' + (b.selected ? ' is-selected' : '') + '" data-i="' + i + '" role="radio" tabindex="0" aria-checked="' + b.selected + '">' +
        '<div class="mvlp-offer__row"><span class="mvlp-offer__radio"></span>' +
        '<div class="mvlp-offer__main"><div class="mvlp-offer__line1"><span class="mvlp-offer__title">' + esc(b.title) + '</span>' +
        (b.badge ? '<span class="mvlp-offer__badge' + (i === bars.length - 1 ? ' is-dark' : '') + '">' + esc(b.badge) + '</span>' : '') + '</div>' +
        '<div class="mvlp-offer__line2">' + esc(b.unit) + ' ' + esc(b.unitLabel.replace(/^\//, '/ ')) + (b.pct ? ' · <strong>' + esc(b.pct) + '</strong>' : '') + '</div></div>' +
        '<div class="mvlp-offer__price"><span class="mvlp-offer__total">' + esc(b.total) + '</span>' + (b.old ? '<span class="mvlp-offer__old">' + esc(b.old) + '</span>' : '') + '</div></div>';
      if (b.selected && b.selects.length) {
        html += '<div class="mvlp-offer__sizes">';
        Array.prototype.forEach.call(b.selects, function (s, j) {
          html += '<label class="mvlp-offer__size"><span>' + (j + 1) + '. pár mérete</span><select data-j="' + j + '">';
          Array.prototype.forEach.call(s.options, function (o) {
            html += '<option value="' + esc(o.value) + '"' + (o.value === s.value ? ' selected' : '') + '>' + esc(o.textContent.replace('-', '–').replace(' ', ' · ')) + '</option>';
          });
          html += '</select></label>';
        });
        html += '</div>';
      }
      html += '</div>';
    });
    box.innerHTML = html;
    var sel = bars.filter(function (b) { return b.selected; })[0];
    var btn = document.querySelector('.product-form__submit');
    if (sel && btn && !btn.disabled) {
      var span = btn.querySelector('span') || btn;
      span.textContent = 'Kosárba — ' + sel.total;
    }
  }

  function mount(k) {
    if (k.dataset.mvlpOffer) return;
    k.dataset.mvlpOffer = '1';
    var box = document.createElement('div');
    box.className = 'mvlp-offer';
    k.parentNode.insertBefore(box, k);
    k.classList.add('mvlp-kaching-hidden');
    var t;
    function later() { clearTimeout(t); t = setTimeout(function () { render(k, box); }, 60); }
    render(k, box);
    new MutationObserver(later).observe(k, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'], characterData: true });

    box.addEventListener('click', function (e) {
      if (e.target.closest('select, label')) return;
      var card = e.target.closest('.mvlp-offer__card'); if (!card) return;
      var bar = k.querySelectorAll('.kaching-bundles__bar')[+card.dataset.i];
      var hit = bar && (bar.querySelector('.kaching-bundles__bar-main') || bar.querySelector('label'));
      if (hit) hit.click();
      later();
    });
    box.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.classList.contains('mvlp-offer__card')) { e.preventDefault(); e.target.click(); }
    });
    box.addEventListener('change', function (e) {
      var s = e.target; if (s.tagName !== 'SELECT') return;
      var bar = k.querySelector('.kaching-bundles__bar--selected');
      var target = bar && bar.querySelectorAll('select.kaching-bundles__bar-variant-select')[+s.dataset.j];
      if (!target) return;
      target.value = s.value;
      target.dispatchEvent(new Event('input', { bubbles: true }));
      target.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function find() {
    var k = document.querySelector('kaching-bundle');
    if (k && k.querySelector('.kaching-bundles__bar')) { mount(k); return true; }
    return false;
  }
  if (!find()) { var n = 0, iv = setInterval(function () { if (find() || ++n > 80) clearInterval(iv); }, 250); }
})();

/* „Jelöld be, ami rád igaz” lista: kattintásra be- és kipipálható */
(function () {
  var TICK = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';
  function set(row, on) {
    var box = row.querySelector('.mvlp-check__box'); if (!box) return;
    box.classList.toggle('mvlp-check__box--on', on);
    box.innerHTML = on ? TICK : '';
    row.setAttribute('aria-checked', on ? 'true' : 'false');
  }
  function init() {
    document.querySelectorAll('.mvlp-check').forEach(function (row) {
      if (row.dataset.mvlpCheck) return;
      row.dataset.mvlpCheck = '1';
      row.setAttribute('role', 'checkbox');
      row.setAttribute('tabindex', '0');
      row.setAttribute('aria-checked', row.querySelector('.mvlp-check__box--on') ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var row = e.target.closest('.mvlp-check'); if (!row) return;
    set(row, row.getAttribute('aria-checked') !== 'true');
  });
  document.addEventListener('keydown', function (e) {
    var row = e.target.closest && e.target.closest('.mvlp-check');
    if (row && (e.key === ' ' || e.key === 'Enter')) { e.preventDefault(); row.click(); }
  });
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();

/* fejléc: lefelé görgetve elrejtjük, felfelé görgetve visszajön */
(function () {
  var h = document.querySelector('.section-header'); if (!h) return;
  var last = window.scrollY;
  function upd() {
    var y = window.scrollY, d = y - last;
    if (y < 120) h.classList.remove('mvlp-hdr-hidden');
    else if (d > 6) h.classList.add('mvlp-hdr-hidden');
    else if (d < -6) h.classList.remove('mvlp-hdr-hidden');
    if (Math.abs(d) > 6) last = y;
  }
  window.addEventListener('scroll', upd, { passive: true });
})();

/* saját lebegő kosár-sáv (az Essential Sticky Cart helyett, csak ezen az oldalon) */
(function () {
  var IMG = 'https://cdn.shopify.com/s/files/1/0938/3457/6198/files/mvlp-felulnezet.jpg?width=120';
  var touched = false;
  document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('.mvlp-offer')) touched = true; });
  function init() {
    var offer = document.querySelector('.mvlp-offer');
    if (!offer) return false;
    var bar = document.createElement('div');
    bar.className = 'mvlp-sbar'; bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<img src="' + IMG + '" alt="" width="44" height="44"><div class="mvlp-sbar__txt"><span class="mvlp-sbar__t"></span><span class="mvlp-sbar__s"></span></div><button type="button" class="mvlp-sbar__btn" tabindex="-1">Kosárba</button>';
    document.body.appendChild(bar);
    var t = bar.querySelector('.mvlp-sbar__t'), s = bar.querySelector('.mvlp-sbar__s'), b = bar.querySelector('.mvlp-sbar__btn');
    function sync() {
      var c = offer.querySelector('.mvlp-offer__card.is-selected'); if (!c) return;
      var title = (c.querySelector('.mvlp-offer__title') || {}).textContent || '';
      var total = (c.querySelector('.mvlp-offer__total') || {}).textContent || '';
      var old = (c.querySelector('.mvlp-offer__old') || {}).textContent || '';
      t.textContent = title + ' · ' + total;
      s.innerHTML = old ? '<s>' + old + '</s> · ingyenes szállítás' : 'Ingyenes szállítás';
      b.textContent = touched ? 'Kosárba' : 'Méretet választok';
    }
    new MutationObserver(sync).observe(offer, { childList: true, subtree: true });
    var shown = false;
    function check() {
      var r = offer.getBoundingClientRect();
      var v = r.bottom < 0;
      if (v !== shown) { shown = v; bar.classList.toggle('is-visible', v); bar.setAttribute('aria-hidden', v ? 'false' : 'true'); b.tabIndex = v ? 0 : -1; }
    }
    b.addEventListener('click', function () {
      var submit = document.querySelector('.product-form__submit');
      if (touched && submit && !submit.disabled) { submit.click(); return; }
      offer.scrollIntoView({ behavior: 'smooth', block: 'center' });
      offer.classList.add('mvlp-offer--pulse'); setTimeout(function () { offer.classList.remove('mvlp-offer--pulse'); }, 1600);
    });
    window.addEventListener('scroll', check, { passive: true }); window.addEventListener('resize', check);
    sync(); check();
    return true;
  }
  if (!init()) { var n = 0, iv = setInterval(function () { if (init() || ++n > 80) clearInterval(iv); }, 250); }
})();

/* menü: a téma oldalpanelje helyett lebegő üvegkártya a fejléc-pill alatt, termékekkel */
(function () {
  var PICKS = [
    ['magneses-akupresszuras-talpbetet', 'Talp & lépés'],
    ['cloudwalk-talpbetet', 'Talp & lépés'],
    ['medivital™-auring-magneses-akupresszuras-gyuru', 'Jóllét & akupresszúra'],
    ['nyaknyujto-es-pihenteto-parna-1', 'Nyak & tartás'],
    ['dekompresszios-nyaknyujto-es-tartasjavito-pad', 'Nyak & tartás'],
    ['medivital-ortoped-gerinc-es-hatnyujto-derektamasz', 'Gerinc & derék'],
    ['termeszetes-alvastapasz', 'Alvás']
  ];
  var css = '' +
    'html body .section-header .menu-drawer{position:absolute!important;top:calc(100% + 10px)!important;left:0!important;width:min(440px,calc(100vw - 24px))!important;height:auto!important;max-height:calc(100vh - 150px);overflow:auto;border-radius:24px;padding:0!important;' +
    'background:rgba(6,46,55,.84)!important;-webkit-backdrop-filter:blur(22px) saturate(1.5);backdrop-filter:blur(22px) saturate(1.5);' +
    'box-shadow:inset 0 0 0 1px rgba(255,255,255,.14),0 20px 50px rgba(6,46,55,.35);color:#FDFBF7;transform:translateY(-8px)!important;opacity:0;transition:opacity .2s ease,transform .2s ease,visibility .2s!important;border:0!important}' +
    'html body .section-header .menu-opening .menu-drawer{transform:none!important;opacity:1}' +
    'html body .section-header .menu-drawer__inner-container{height:auto!important}' +
    'html body .section-header .menu-drawer__navigation-container{display:block!important;height:auto!important}' +
    'html body .section-header .menu-drawer__navigation{padding:18px 18px 4px!important}' +
    'html body .section-header .menu-drawer__menu{display:flex!important;flex-wrap:wrap;gap:8px}' +
    'html body .section-header .menu-drawer__menu li{margin:0!important}' +
    'html body .section-header .menu-drawer__menu-item{display:inline-flex!important;min-height:36px;padding:8px 14px!important;border-radius:999px;background:rgba(255,255,255,.10);color:#FDFBF7!important;font-family:"DM Sans",sans-serif;font-size:14px!important;font-weight:500;text-decoration:none!important;white-space:normal;line-height:1.3}' +
    'html body .section-header .menu-drawer__menu-item:hover{background:rgba(255,255,255,.18)}' +
    'html body .section-header .menu-drawer__utility-links{display:none!important}' +
    'html body .section-header .menu-drawer__menu li:has(a[href*="magneses-akupresszuras-talpbetet"]){display:none!important}' +
    'html body .section-header .menu-drawer__menu-item{max-width:100%;overflow:hidden;text-overflow:ellipsis;align-items:center}' +
    '.mvlp-menu{padding:14px 18px 18px;font-family:"DM Sans",sans-serif}' +
    '.mvlp-menu__eyebrow{font-size:11px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;color:rgba(201,239,236,.85);margin:4px 2px 10px}' +
    '.mvlp-menu__item{display:flex;align-items:center;gap:14px;padding:9px 8px;border-radius:16px;text-decoration:none;color:#FDFBF7}' +
    '.mvlp-menu__item:hover{background:rgba(255,255,255,.08)}' +
    '.mvlp-menu__item img{width:60px;height:60px;border-radius:14px;object-fit:cover;background:#fff;flex-shrink:0;box-shadow:0 0 0 1px rgba(255,255,255,.15)}' +
    '.mvlp-menu__meta{display:flex;flex-direction:column;gap:3px;min-width:0}' +
    '.mvlp-menu__row{display:flex;align-items:center;gap:8px}' +
    '.mvlp-menu__rank{display:inline-flex;align-items:center;height:20px;padding:0 8px;border-radius:999px;background:#C9EFEC;color:#0F2E38;font-size:11px;font-weight:700}' +
    '.mvlp-menu__cat{font-size:12px;color:rgba(253,251,247,.7)}' +
    '.mvlp-menu__title{font-size:15px;font-weight:600;line-height:1.25;letter-spacing:-.01em}' +
    '.mvlp-menu__all{display:flex;justify-content:flex-end;padding:10px 6px 0}' +
    '.mvlp-menu__all a{color:#C9EFEC;font-size:14px;font-weight:600;text-decoration:underline;text-underline-offset:4px}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function build() {
    var nav = document.querySelector('.section-header .menu-drawer__navigation-container');
    if (!nav || nav.querySelector('.mvlp-menu')) return;
    var box = document.createElement('div'); box.className = 'mvlp-menu';
    nav.appendChild(box);
    fetch('/collections/all/products.json?limit=250').then(function (r) { return r.json(); }).then(function (d) {
      var by = {}; (d.products || []).forEach(function (p) { by[p.handle] = p; });
      var html = '<div class="mvlp-menu__eyebrow">Legnépszerűbb termékeink</div>', n = 0;
      PICKS.forEach(function (pk) {
        var p = by[pk[0]]; if (!p) return; n++;
        var img = p.images && p.images[0] ? p.images[0].src + (p.images[0].src.indexOf('?') > -1 ? '&' : '?') + 'width=160&height=160&crop=center' : '';
        html += '<a class="mvlp-menu__item" href="/products/' + encodeURIComponent(p.handle) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="60" height="60">' : '') +
          '<span class="mvlp-menu__meta"><span class="mvlp-menu__row"><span class="mvlp-menu__rank">#' + n + '</span><span class="mvlp-menu__cat">' + esc(pk[1]) + '</span></span><span class="mvlp-menu__title">' + esc(p.title.replace(/™/g, '')) + '</span></span></a>';
      });
      html += '<div class="mvlp-menu__all"><a href="/collections/termekek">Összes termék →</a></div>';
      box.innerHTML = html;
    }).catch(function () { box.remove(); });
  }
  if (document.readyState !== 'loading') build(); else document.addEventListener('DOMContentLoaded', build);
})();
